export const statusTextHeadingId = 'study-stack-status-text';
